import { useAlgoList } from './queries/algoQueries';

export const useAlgoSimple = (params = {}) => {
  const { data: algoList, isLoading: algoListLoading, error: algoListError, refetch: refetchAlgoList } = useAlgoList(params);
  const totalCount = algoList?.Total || algoList?.total || algoList?.length;

  const putAlgoToDrResource = (algo) => {
    
  };
  
  return { algoList, algoListLoading, algoListError, refetchAlgoList, totalCount };
};

export default useAlgoSimple;
